import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { platformSelect } from '@bubble-ui/util-platform';
export var getDefaultStyleSheet = _ref => {
  var {
    backgroundColorToken,
    backgroundColorTokenArgs,
    canBeCleared,
    designContext,
    disabled,
    hasValue,
    hovered,
    isMedium,
    pressed,
    width,
    withIcon
  } = _ref;
  var interactiveState = disabled ? 'disabled' : pressed ? 'pressed' : hovered ? 'hovered' : 'default';
  var inputTextColor = designContext.get('field-simple/input-text-color', {
    interactiveState
  }).toString();
  var labelTextColor = designContext.get('field-simple/label-text-color', {
    interactiveState
  }).toString();
  var backgroundColor = designContext.get(backgroundColorToken || 'field-simple/background-color', _objectSpread({
    interactiveState
  }, backgroundColorToken ? backgroundColorTokenArgs : {})).toString();
  var borderRadius = designContext.get('field-simple/corner-radius').pixelValue;
  return {
    containerStyle: _objectSpread(_objectSpread({
      alignItems: 'stretch',
      borderRadius,
      borderStyle: 'solid',
      boxSizing: 'border-box',
      flexDirection: 'row',
      flexGrow: 1,
      flexShrink: 1,
      height: isMedium ? 40 : 50,
      justifyContent: 'space-between'
    }, withIcon ? {
      paddingTop: 15,
      paddingBottom: 15,
      paddingLeft: 10,
      paddingRight: 15
    } : {
      padding: 15
    }), {}, {
      position: 'relative',
      backgroundColor
    }),
    iconStyle: {
      alignSelf: 'center',
      height: 20,
      paddingRight: 5
    },
    iconColor: {
      colorToken: hasValue ? 'field-simple/input-text-color' : 'field-simple/label-text-color',
      colorTokenArgs: {
        interactiveState
      }
    },
    labelViewStyle: _objectSpread(_objectSpread({
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      opacity: hasValue ? 0 : 1,
      pointerEvents: 'none',
      height: isMedium ? 40 : 50,
      left: 0,
      paddingLeft: withIcon ? 35 : 15
    }, platformSelect({
      web: {
        paddingRight: 15
      },
      default: {}
    })), {}, {
      paddingTop: 0,
      position: 'absolute',
      transition: 'opacity .2s ease',
      top: 0,
      paddingBottom: 0,
      marginTop: 0,
      width: width !== undefined ? width : '100%',
      // Vertically centering label text on native:
      justifyContent: 'center'
    }),
    labelTextStyle: _objectSpread(_objectSpread({
      color: labelTextColor
    }, designContext.get('field-simple/label-text-style').styles()), {}, {
      overflow: 'hidden',
      textAlign: 'left',
      textOverflow: 'ellipsis',
      transition: 'color .2s ease',
      whiteSpace: 'nowrap',
      width: '100%',
      // Vertically centering label text on web:
      display: 'flex',
      alignItems: 'center'
    }),
    inputStyle: _objectSpread(_objectSpread(_objectSpread({
      boxShadow: 'none',
      caretColor: inputTextColor,
      color: inputTextColor
    }, platformSelect({
      web: {
        WebkitTextFillColor: inputTextColor
      },
      default: {}
    })), designContext.get('field-simple/input-text-style').styles()), {}, {
      height: isMedium ? 40 : 50,
      left: 0,
      overflow: 'hidden',
      paddingLeft: withIcon ? 35 : 15,
      paddingRight: canBeCleared ? 35 : 15,
      paddingTop: 0,
      position: 'absolute',
      transition: 'color .2s ease',
      top: 0,
      paddingBottom: 0,
      marginTop: 0,
      whiteSpace: 'nowrap',
      width: width !== undefined ? width : '100%'
    }),
    clearIconWrapperStyle: {
      display: canBeCleared ? 'flex' : 'none',
      position: 'absolute',
      top: isMedium ? 10 : 15,
      right: 10
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map